import React, { useEffect, useState } from 'react'
import Papa from 'papaparse'
import { signOut } from 'firebase/auth'
import { auth } from '../firebase'

import GenderChart from '../components/GenderChart'
import AgeChart from '../components/AgeChart'
import IncomeChart from '../components/IncomeChart'
import EducationChart from '../components/EducationChart'
import TopBehaviors from '../components/TopBehaviors'
import DevicesChart from '../components/DevicesChart'
import TopRegion from '../components/TopRegion'
import ChildrenChart from '../components/ChildrenChart'

const csvURL = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data.csv'

const Dashboard = ({ user, onLogout }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetch(csvURL)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch CSV data')
        return res.text()
      })
      .then((text) => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            setData(results.data)
            setLoading(false)
          },
          error: (err) => {
            console.error('Parsing error:', err)
            setError('Failed to parse CSV data')
            setLoading(false)
          }
        })
      })
      .catch((err) => {
        console.error('Fetch error:', err)
        setError('Error loading CSV data')
        setLoading(false)
      })
  }, [])

  if (loading) {
    return <div className="p-6 text-gray-500">Loading data...</div>
  }

  if (error) {
    return <div className="p-6 text-red-500">Error: {error}</div>
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <GenderChart data={data} />
        <AgeChart data={data} />
        <TopBehaviors data={data} />
        <IncomeChart data={data} />
        <ChildrenChart data={data} />
        <EducationChart data={data} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <DevicesChart data={data} />
        <TopRegion data={data} />
      </div>
    </div>
  )
}

export default Dashboard
